import { get } from 'lodash-es'

import TYPES from './getter-types'
import CONST from './brands-constants'
import STORE_CONSTANTS from '@/js/plugins/store/utils/store-constants.js'

import { getBrandById } from './helper'

export default {
  [TYPES.LOGO_DATA]: state => brand => {
    return get(getBrandById(state, brand), CONST.LOGO_DATA)
  },
  [TYPES.BRAND_NAME]: state => brand => {
    return get(getBrandById(state, brand), CONST.BRAND_NAME)
  },
  [TYPES.BRAND]: state => brand => {
    return getBrandById(state, brand)
  },
  [TYPES.BRANDS]: state => {
    return Object.values(get(state, STORE_CONSTANTS.BY_ID, {}))
  },
}
